import React, { lazy } from 'react';
import { motion } from 'framer-motion';
export function FinalCTA() {
  return <section className="bg-cream py-[32px] md:py-[48px] px-6" data-id="element-88">
      <div className="max-w-[860px] mx-auto text-center" data-id="element-89">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-90">
          <div className="mb-10 max-w-[720px] mx-auto" data-id="element-91">
            <img src="https://cdn.magicpatterns.com/uploads/3NgERfy7hpbfpoXkc8fTJy/Glicacion.png" alt="De la incertidumbre a la calma: un hombre revisa su glucosa con preocupación mientras otro, ya informado, lee tranquilo junto a la ventana." className="w-full h-auto rounded-[16px] shadow-[0_8px_32px_rgba(43,39,36,0.10)]" loading="lazy" data-id="element-92" />
          </div>

          <h2 className="font-serif font-bold text-[36px] md:text-[42px] leading-[1.15] text-text-primary mb-6 max-w-[720px] mx-auto" data-id="element-93">
            La glicación no espera.
            <br data-id="element-94" />
            Tu decisión <span className="italic text-cocoa" data-id="element-95">
              informada
            </span>{' '}
            empieza hoy.
          </h2>

          <p className="font-sans text-[16px] leading-[1.8] text-text-secondary max-w-[480px] mx-auto mb-8" data-id="element-96">
            Cada día que pasa sin esta información, el proceso sigue avanzando
            en silencio.
          </p>

          <div className="max-w-[440px] mx-auto" data-id="element-97">
            <a href="#comprar" className="premium-btn-cocoa block w-full mb-3" data-id="element-98">
              🔒 SÍ QUIERO EL MAPA COMPLETO — $17.95 USD
            </a>

            <p className="font-sans text-[12px] text-text-muted text-center" data-id="element-99">
              Libro + 3 bonos · Acceso inmediato · Garantía 7 días sin preguntas
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}